"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Tracker_1 = require("@/classes/Tracker");
const routes_1 = require("@/enums/routes");
const store_1 = __importDefault(require("@/store"));
class Introduction {
    startTest() {
        Tracker_1.CountryTestTracker.fireTracking('test_start');
        store_1.default.mutations.setCurrentRoute(routes_1.Routes.QUESTION, {
            questionId: 0
        });
    }
    ;
}
exports.default = Introduction;
